import React from 'react';
import Game from './components/Game'
import './css/main.css'; // Tell webpack that Button.js uses these styles

const App = () => <Game />;

export default App;
